// Entity definition for physiologicalData
export interface IPhysiologicalData {
  id: number;
  dateMeasured: Date;
  physiologicalTypeName: string;
  physiologicalTypeID: number;
  unitName: string;
  unitID: number;
  subtypes: string;
  onlyShowInTypeSelection: boolean;
  value: string;
};

export class physiologicalData implements IPhysiologicalData {
  id: number;
  dateMeasured: Date;
  physiologicalTypeName: string;
  physiologicalTypeID: number;
  unitName: string;
  unitID: number;
  subtypes: string;
  value: string;
  onlyShowInTypeSelection: boolean;

  constructor(data: IPhysiologicalData) {
    this.id = data.id;
    this.dateMeasured = data.dateMeasured;
    this.physiologicalTypeName = data.physiologicalTypeName;
    this.physiologicalTypeID = data.physiologicalTypeID;
    this.unitName = data.unitName;
    this.unitID = data.unitID;
    this.subtypes = data.subtypes;
    this.value = data.value;
    this.onlyShowInTypeSelection = data.onlyShowInTypeSelection;
  }
}

export interface IUnit {
  id: number;
  name: string;
}

export class Unit implements IUnit {
  id: number;
  name: string;

  constructor(data: IUnit) {
    this.id = data.id;
    this.name = data.name;
  }
}

export interface IPhysiologicalType {
  id: number;
  name: string;
  unitName: string;
  unitID: number;
  subtypes: string;
  abbreviation: string;
  onlyShowInTypeSelection: boolean;
  preferredUnit: number;
}

export class PhysiologicalType implements IPhysiologicalType {
  id: number;
  name: string;
  unitName: string;
  unitID: number;
  subtypes: string;
  abbreviation: string;
  onlyShowInTypeSelection: boolean;
  preferredUnit: number;

  constructor(data: IPhysiologicalType) {
    this.id = data.id;
    this.name = data.name;
    this.unitName = data.unitName;
    this.unitID = data.unitID;
    this.subtypes = data.subtypes;
    this.abbreviation = data.abbreviation;
    this.onlyShowInTypeSelection = data.onlyShowInTypeSelection;
    this.preferredUnit = data.preferredUnit;
  }
}

export interface IPhysiologicalDataDetails {
  id: number;
  dateMeasured: Date;
  value: string;
  physiologicalTypeID: number;
  unitID: number;
  units: IUnit[];
  onlyShowInTypeSelection: boolean;
  physiologicalTypes: IPhysiologicalType[];
};

export class PhysiologicalDataDetails implements IPhysiologicalDataDetails {
  id: number;
  dateMeasured: Date;
  value: string;
  physiologicalTypeID: number;
  unitID: number;
  units: IUnit[];
  physiologicalTypes: IPhysiologicalType[];
  onlyShowInTypeSelection: boolean;

  constructor(data: IPhysiologicalDataDetails) {
    this.id = data.id;
    this.dateMeasured = data.dateMeasured;
    this.value = data.value;
    this.physiologicalTypeID = data.physiologicalTypeID;
    this.unitID = data.unitID;
    this.units = data.units;
    this.physiologicalTypes = data.physiologicalTypes;
    this.onlyShowInTypeSelection = data.onlyShowInTypeSelection;
  }
}